module.exports = __webpack_public_path__ + "media/images/mercy-icon-7d0303f7db46061f0cc932bc1ab2e3c4.png";